import axios from 'axios'
import router from '../router'
import { createStore } from 'vuex'

export default createStore({
    state: {
        loggedIn: false,
        loginErrorMessage: '',
        userData: {
            loaded: false,
            loaded_from: '',
            content: {},
        },
        configurationType: '',
        configurationName: '',
        configurationId:   '',
        configuratorSaving: false,
        buyOverlayVisible: false,
        shareOverlayVisible: false,
        newTouchFlexInterfaceVisible: false,
        newTouchFlexConfiguration: {},
        showLaserOverlay: false,
        flexSearchTerm: '',
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})
